import { Injectable } from "@angular/core";
import { Router, CanActivate, CanActivateChild, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";

import {  AuthenticationService } from "../service/authentication.service";
import { environment } from "../../../environments/environment";


@Injectable()
export class AuthenticationGuard implements CanActivate, CanActivateChild {
  constructor(
    private readonly router: Router,
    private readonly authenticationService: AuthenticationService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkUserIsAuthenticated(route, state);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkUserIsAuthenticated(route, state);
  }

  checkUserIsAuthenticated(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (this.authenticationService.getUser()) {
      return true;
    }


    this.router.navigate(["login"], { replaceUrl: true });
    return false;
  }
}
